/**
 * The ONLY place the web app touches web storage, and it stores one thing: the language
 * code the visitor picked ('en' or 'es'). Never a token, address, code or customer id
 * (the session is the HttpOnly cookie; src/__tests__/security.test.ts enforces this).
 */

import type { Lang } from '@portal-contract';

const KEY = 'portal-lang';

export function readStoredLang(): Lang | null {
  try {
    const v = window.localStorage.getItem(KEY);
    return v === 'en' || v === 'es' ? v : null;
  } catch {
    return null;
  }
}

export function writeStoredLang(lang: Lang): void {
  try {
    window.localStorage.setItem(KEY, lang);
  } catch {
    /* storage can be blocked (private windows, strict settings); the toggle still works for this page load */
  }
}
